import { ITab } from '@hooks/useTab';
import { Tabs, TabsProps } from '@material-ui/core';
import React from 'react';

export type TabControlProps = TabsProps & {
    tab: ITab
}

export function TabControl ({tab, ...props}: TabControlProps) {
    return (
        <Tabs value={tab.tabIndex} onChange={tab.handleTabChange} {...props} />
    )
}